import React, { useState, useEffect, useCallback, useMemo } from 'react';
import './WordFlip.css';

// Default: starts at Standardize, cycles through all, stops back at Standardize
const defaultWords = [
  'Standardize',
  'Smarten',
  'Transform',
  'Streamline',
  'Level-up',
  'Standardize',
];

export default function WordFlip({ words: propWords }) {
  const words = useMemo(
    () => (Array.isArray(propWords) && propWords.length > 0 ? propWords : defaultWords),
    [propWords]
  );
  const longestWord = useMemo(
    () => words.reduce((a, b) => (a.length >= b.length ? a : b), ''),
    [words]
  );

  const [current, setCurrent] = useState(0);
  const [previous, setPrevious] = useState(null);
  const [animating, setAnimating] = useState(false);
  const [stopped, setStopped] = useState(false);

  // Reset animation if the words list changes (e.g. language switch)
  useEffect(() => {
    setCurrent(0);
    setPrevious(null);
    setAnimating(false);
    setStopped(false);
  }, [words]);

  useEffect(() => {
    if (stopped) return;
    const interval = setInterval(() => {
      setPrevious(current);
      setCurrent((prev) => {
        const next = prev + 1;
        if (next >= words.length - 1) {
          setStopped(true);
        }
        return next;
      });
      setAnimating(true);
    }, 2500);
    return () => clearInterval(interval);
  }, [current, stopped, words]);

  const handleAnimationEnd = useCallback(() => {
    setAnimating(false);
    setPrevious(null);
  }, []);

  return (
    <span className="word-flip">
      {/* Invisible spacer — always holds the width of the longest word */}
      <span className="word-flip__spacer" aria-hidden="true">{longestWord}</span>

      {/* Visible animated words layered on top */}
      <span className="word-flip__container">
        {animating && previous !== null && (
          <span className="word-flip__word word-flip__word--exit">
            {words[previous]}
          </span>
        )}
        <span
          className={`word-flip__word${animating ? ' word-flip__word--enter' : ''}`}
          onAnimationEnd={handleAnimationEnd}
        >
          {words[current]}
        </span>
      </span>
    </span>
  );
}
